import { fg } from '@atlassian/jira-feature-gating';

const AgentsFieldWivRelayProvider = {
	get(): boolean {
		return fg('agents_field_wiv');
	},
};

export default AgentsFieldWivRelayProvider;
